export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const APP_NAME = process.env.REACT_APP_STORE_NAME;
export const APP_LOGO = "../../../assets/images/logo.png";
export const BANNER_IMG = "assets/images/banner.png";
export const GLOBAL_CURRENCY = {
    symbol: "R",
    code: "ZAR",
    name: "South African Rand"
}
export const GLOBAL_COUNTRY_CODE = {
    "flag": "https://geo5.net/imagens/Bandeira-da-Africa-do-Sul.png",
    "name": "South Africa",
    "dial_code": "27",
    "code": "SA"
}

export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_API

export const APP_ENV = process.env.REACT_APP_ENV;
export const ERROR_LOGGING_FLAG = process.env.REACT_APP_ERROR_LOGGING;
export const APP_VERSION = process.env.REACT_APP_VERSION || "unknown";
export const FIREBASE_CONFIG = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
export const TERMS_OF_SERVICE = 'https://www.venturestudiocms.com/api/general-pages/91?populate=hero_section.media, description.paragraphs.media,other_content_blocks.media,quick_links.cards.media'
export const PRIVACY_POLICY = 'https://www.venturestudiocms.com/api/general-pages/90?populate=hero_section.media, description.paragraphs.media,other_content_blocks.media,quick_links.cards.media'

// export const ENABLED_D6_FEATURE= ["d6auth.vercel.app"]
export const ENABLED_D6_FEATURE = [ "localhost:3002", "mclardies.webbieshop.com","d6auth.vercel.app","broadacreschartwell.webbieshop.com","broadacressyringa.webbieshop.com","qiatuckshop.webbieshop.com","estcourtuniformshop.webbieshop.com"]
export const IS_BETA = ["d6auth.vercel.app"]
export const IS_LIVE = ["mclardies.webbieshop.com"]
